import color from "./color.js"
import link from "./link.js"
import script from "./script.js"
import viewport from "./viewport.js"
import sanitizer from './sanitizer.js'

export default {
  viewport,
  script,
  link,
  color,
  sanitizer,
}